// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9237c63d","257":"ded4dc9e","455":"fc9d9d88","477":"6bfedbf6","609":"1a379c00","884":"5d66b327","977":"8289928e"}[chunkId] + ".chunk.js";
};